/**
 * Procedure Categories and Procedures for M.Ch. in Reproductive Medicine and Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 6-7, 24-25: "Psychomotor domain - perform independently")
 */
export const REPRODUCTIVE_MEDICINE_PROCEDURES = {
  "Assisted Reproductive Technology (ART) & Andrology Procedures": [
    "Intrauterine Insemination (IUI) & Semen Sample Preparation",
    "Ultrasound-Guided Oocyte Retrieval (Follicular Aspiration) & Embryo Transfer (Fresh & Frozen)",
    "Intra Cytoplasmic Sperm Injection (ICSI), In Vitro Fertilization (IVF) & In Vitro Maturation (IVM)",
    "Oocyte, Embryo & Semen Cryopreservation (Vitrification)",
    "Surgical Sperm Retrieval (TESE, TESA, PESA, MESA & Open Testicular Biopsy)",
    "Semen Analysis & Sperm Function Testing",
  ],
  "Endoscopic, Microsurgical & Fertility-Enhancing Reproductive Surgeries": [
    "Diagnostic & Operative Laparoscopy (Ovarian Drilling, Cystectomy, Salpingectomy for Ectopic/Hydrosalpinx)",
    "Laparoscopic & Open Myomectomy & Surgical Management of Endometriosis",
    "Diagnostic & Operative Hysteroscopy (Polypectomy, Myomectomy, Septal Resection & Adhesiolysis for Asherman Syndrome)",
    "Laparoscopic & Open Tubal Recanalization / Reversal of Sterilization",
    "Reconstructive Vaginal & Uterine Surgery (Vaginoplasty, Vaginal Septum Excision, Metroplasty)",
    "Diagnostic Hysterosalpingography (HSG) & Saline Sonosalpingography (SSG / SIS)",
  ],
};

export const REPRODUCTIVE_MEDICINE_CATEGORIES = Object.keys(REPRODUCTIVE_MEDICINE_PROCEDURES);

export const isMChInReproductiveMedicineDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    d.includes("reproductive medicine") ||
    d.includes("reproductive medicine and surgery") ||
    d.includes("infertility")
  );
};
